import React from 'react';
import ProviderMeasurements from '../ProviderMeasurements';

const MUTED = '#595959';

// Raw 3DLOOK body measurements frozen on the order — shown separately from garment cutting values.
export const OrderScanMeasurements = ({ order }) => {
  const pm = order.provider_measurements;
  const summary = order.body_measurements || {};
  const summaryKeys = Object.keys(summary).filter(k =>
    typeof summary[k] === 'number' && !(k === 'bust' && summary.bust === summary.chest));

  return (
    <div className="mb-3" data-testid="order-scan-measurements">
      <p className="text-[9px] tracking-[0.14em] uppercase mb-1" style={{ color: '#8a8a8a' }}>
        Body Scan · 3DLOOK provider measurements
      </p>
      <p className="text-[10px] mb-1.5" style={{ color: MUTED }}>
        Raw body measurements — no ease added. These are not garment cutting sizes.
      </p>
      <div className="border" style={{ borderColor: '#E5E5E5' }}>
        {pm?.count > 0 ? (
          <ProviderMeasurements data={pm} />
        ) : summaryKeys.length > 0 ? (
          <div data-testid="order-scan-summary-fallback">
            <p className="px-3 py-2 text-[10px]" style={{ color: '#9A6A0F' }}>
              Full 3DLOOK dataset was not stored for this order. Showing the summary body values saved with the order.
            </p>
            {summaryKeys.map(k => (
              <div key={k} className="px-3 py-1.5 flex justify-between border-b" style={{ borderColor: '#F5F5F5' }}>
                <span className="text-[12px] capitalize" style={{ color: '#0F0F0F' }}>{k.replace(/_/g, ' ')}</span>
                <span data-testid={`order-scan-summary-${k}`} className="text-[13px] tabular-nums">{summary[k]} cm</span>
              </div>
            ))}
          </div>
        ) : (
          <p data-testid="order-scan-none" className="px-3 py-2 text-[11px]" style={{ color: MUTED }}>
            No 3DLOOK body scan is attached to this order.
          </p>
        )}
      </div>
    </div>
  );
};

export default OrderScanMeasurements;
